var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23.2347C5.28663 23.2347 0.25 18.198 0.25 11.9847C0.25 5.77129 5.28663 0.734665 11.5 0.734665C17.7134 0.734665 22.75 5.77129 22.75 11.9847C22.75 18.198 17.7134 23.2347 11.5 23.2347ZM11.5 20.9847C13.8869 20.9847 16.1761 20.0365 17.864 18.3486C19.5518 16.6608 20.5 14.3716 20.5 11.9847C20.5 9.59772 19.5518 7.30853 17.864 5.6207C16.1761 3.93288 13.8869 2.98466 11.5 2.98466C9.11305 2.98466 6.82387 3.93288 5.13604 5.6207C3.44821 7.30853 2.5 9.59772 2.5 11.9847C2.5 14.3716 3.44821 16.6608 5.13604 18.3486C6.82387 20.0365 9.11305 20.9847 11.5 20.9847V20.9847ZM11.5 10.3939L14.6815 7.21129L16.2734 8.80316L13.0907 11.9847L16.2734 15.1662L14.6815 16.758L11.5 13.5754L8.3185 16.758L6.72662 15.1662L9.90925 11.9847L6.72662 8.80316L8.3185 7.21129L11.5 10.3939Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.68e7980a8dcecb2fb7e2e1165477fa84.svg";
export { ForwardRef as ReactComponent };